<template>
  <div>
    <el-dialog
      :visible.sync="centerDialogVisible"
      width="35%"
      center
      class="ne-oppop"
      v-if="this.selectedPlan[0].subscription.name !== ''"
    >
      <div class="bg-primary p-4 flex justify-between items-center">
        <h2 class="text-white fsize14 my-0">Billing</h2>
        <feather-icon
          icon="XIcon"
          svgClasses="w-4 h-4"
          class="cursor-pointer text-white"
          @click="
            () => {
              centerDialogVisible = false;
            }
          "
        />
      </div>
      <div class="p-4 items-center">
        <div class="flex justify-center w-full">
          <img
            src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/hello.png"
            class="new-height"
          />
        </div>

        <p class="fsize14 text-dark text-center font-medium my-4">
          Billing is available only for other BRAINED's Subscription Plans.
          Please upgrade to other plan to access this feature
        </p>

        <div class="flex w-full mt-4 gap-2">
          <vs-button
            color="primary"
            class="bg-primary w-full"
            @click="
              () => {
                centerDialogVisible = false;
                this.$router.push({ name: 'plans-vue' });
              }
            "
            >Upgrade</vs-button
          >

          <vs-button
            color="secondary"
            class="bg-secondary w-full"
            @click="centerDialogVisible = false"
            >Cancel</vs-button
          >
        </div>
      </div>
    </el-dialog>
    <el-card
      :body-style="{ padding: '0px', height: '100%' }"
      class="bg-white border-0 fixed leftmenu-fixed lg:w-2/12 md:w-1/4"
    >
      <div class="py-2 h-90vh relative">
        <div class="flex items-center justify-center mt-4 px-6 gap-2">
          <div>
            <img
              :src="
                brandProfile.primaryLogo
                  ? url1 + '/' + brandProfile.primaryLogo
                  : 'https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/react/default.png'
              "
              class="w-full h-16 rounded-md object-contain"
              alt="logo"
            />
          </div>
          <div class="pl-1">
            <!-- <h2 class="text-dark fsize15 mb-0 mt-0 font-semibold uppercase">
            {{ selectedProject.displayName }}
          </h2>
          <p
            class="font-semibold fsize10 text-dark font-medium flex items-center"
          >
            View more details
          </p> -->
          </div>
        </div>
        <!-- menuoptionscroll for scroll -->

        <!-- <p class="text-primary font-semibold pl-6 pt-4">Menu</p> -->
        <div class="pt-4 pb-6 fixedmenu-scroll">
          <!-- <div
            class="items-center flex py-3 effect px-6 mb-1 d-flex"
            v-for="(item, index) in filteredMenu"
            :key="'item -' + index"
            @click="handleClick(item.route, item) && selected(item.route)"
            :class="
              $route.name === item.route
                ? 'bg-f5f5f5' && 'cursor-pointer'
                : '' && this.selectedProject.intellectualProperty === true
                ? item.route === 'dashboard' || item.route === 'controlCenter'
                  ? 'cursor-pointer'
                  : 'bg-f5f5f5' && 'cursor-not-allowed'
                : ''
            "
          > -->
          <div
            class="items-center flex py-3 effect px-6 d-flex"
            v-for="(item, index) in filteredMenu"
            :key="index"
            @click="
              selectedProject.intellectualProperty === true
                ? item.name === 'Dashboard' ||
                  item.name === 'Control Center' ||
                  item.name === 'My Admin'
                  ? handleClick(item.route, item) && selected(item.route)
                  : selectedProject.intellectualProperty === false
                  ? handleClick(item.route, item) && selected(item.route)
                  : ''
                : handleClick(item.route, item) && selected(item.route)
            "
            :class="
              selectedProject.intellectualProperty === true
                ? item.name === 'Dashboard' ||
                  item.name === 'Control Center' ||
                  item.name === 'My Admin'
                  ? 'cursor-pointer'
                  : 'cursor-not-allowed opacity'
                : selectedProject.intellectualProperty === false
                ? 'cursor-pointer'
                : ''
            "
          >
            <!-- <feather-icon svgClasses="w-4 h-4" :icon="item.icon" class="">
        </feather-icon> -->
            <img
              :src="item.image"
              class="object-contain w-8 h-8 bg-light-primary rounded-full p-1"
              alt="sidebar"
            />
            <p
              class="font-medium fsize12 mb-0 px-4 items-center"
              :class="{
                'text-primary font-bold':
                  $route.name === item.route || checkInternalRoute(item.route),
              }"
            >
              {{ item.title }}
            </p>
          </div>
        </div>
        <div class="pb-8 bg-f4f5f699 w-full bottom-0 absolute">
          <div
            class="items-center cursor-pointer py-3 effect px-5 flex"
            @click="handleBilling"
          >
            <img
              src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/admin/marcom/Get%20an%20App.svg"
              class="object-contain w-8 h-8 bg-light-primary rounded-full p-1"
              alt="sidebar"
              @click="handleClick('billing')"
            />
            <p class="font-medium fsize12 mb-0 px-4 items-center">Billing</p>
          </div>
          <div
            class="items-center cursor-pointer py-3 effect px-5 flex"
            @click="handleCome('coming')"
          >
            <img
              src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/admin/marcom/Get%20an%20App.svg"
              class="object-contain w-8 h-8 bg-light-primary rounded-full p-1"
              alt="sidebar"
            />
            <p class="font-medium fsize12 mb-0 px-4 items-center">Helpdesk</p>
          </div>

          <div
            class="items-center cursor-pointer py-3 effect px-5 flex"
            @click="logout"
          >
            <!-- <feather-icon svgClasses="w-4 h-4" :icon="item.icon" class="">
        </feather-icon> -->
            <img
              src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/admin/marcom/Get%20an%20App.svg"
              class="object-contain w-8 h-8 bg-light-primary rounded-full"
              alt="sidebar"
            />
            <p class="font-medium fsize12 mb-0 px-4 items-center">Logout</p>
          </div>
        </div>
        <div
          class="absolute bottom-0 pb-2 px-4 w-full bg-white pt-2"
          v-if="latestVersion"
        >
          <p class="fsize12 font-semibold">
            {{ "version " + latestVersion.versionNumber }}
          </p>
        </div>
      </div>
    </el-card>
  </div>
</template>
<script>
import { mapState } from "vuex";
// import { ChevronUpIcon } from "vue-feather-icons";
// import { ChevronDownIcon } from "vue-feather-icons";
// import { PlayCircleIcon } from "vue-feather-icons";

export default {
  data() {
    return {
      adminCustomPages: "",
      url1: this.$imageURL,
      isSelected: {},
      centerDialogVisible: false,
      modules: [],
      class1: "",
      DIndex: [
        {
          id: "01",
          image: require("@/assets/images/icons/Dashboard.svg"),
          title: "Dashboard",
          name: "Dashboard",
          route: "dashboard",
          includes: [],
        },
        {
          id: "10",
          image: require("@/assets/images/icons/My admin.svg"),
          title: "My Admin",
          name: "My Admin",
          route: "myAdmin",
          includes: [],
        },
        {
          id: "04",
          image: require("@/assets/images/icons/Controll center.svg"),
          title: "Control Center",
          name: "Control Center",
          route: "controlCenter",
          includes: [
            "Admin",
            "Ecommerce",
            "Performance",
            "Payment Gateway",
            "Domain",
            "Notification",
            "Email Templates",
            "SMS Templates",
            "Version",
            "Admin Management",
            "Error Management",
            "Google Analytics",
            "Role Management",
            "Contact Us",
            "Intellectual Property",
          ],
        },
        {
          id: "12",
          image: require("@/assets/images/icons/Billing.svg"),
          title: "CMS",
          name: "CMS",
          route: "cmsmanagement",
          includes: ["Admin"],
        },
        // {
        //   id: "03",
        //   image: require("@/assets/images/icons/Branding.svg"),
        //   title: "Branding",
        //   name: "Branding",
        //   route: "branding",
        // },
        {
          id: "02",
          image: require("@/assets/images/icons/Marcomm.svg"),
          title: "Marcom",
          name: "Marcom",
          route: "marcom",
          includes: ["Admin", "Marcom", "Branding"],
        },

        {
          id: "05",
          image: require("@/assets/images/icons/Builder.svg"),
          title: "Builder",
          name: "Builder",
          route: "builder",
          includes: ["Admin", "Builder"],
        },
        // {
        //   id: "06",
        //   image: require("@/assets/images/icons/Studio 1.svg"),
        //   title: "Studio",
        //   name: "Studio",
        //   route: "studio",
        //   includes: ["Admin", "Studio"],
        // },
        {
          id: "07",
          image: require("@/assets/images/icons/Extension 1.svg"),
          title: "Extentions",
          name: "Extention",
          route: "extentions",
          includes: ["Admin"],
        },
        {
          id: "08",
          image: require("@/assets/images/icons/Add ons.svg"),
          title: "Add-ons",
          name: "Add-ons",
          route: "Add-Ons",
          includes: ["Admin"],
        },
        // {
        //   id: "09",
        //   image: require("@/assets/images/icons/Billing.svg"),
        //   title: "Billing",
        //   name: "Billing",
        //   route: "billing",
        //   includes: ["Billing"],
        // },
        // {
        //   id: "10",
        //   image: require("@/assets/images/icons/Billing.svg"),
        //   title: "Get the App",
        //   name: "Get the App",
        //   route: "coming-mobile",
        //   includes: ["Admin"],
        // },
        // {
        //   id: "11",
        //   image: require("@/assets/images/icons/Billing.svg"),
        //   title: "Documentation",
        //   name: "Documentation",
        //   // route: "coming-mobile",
        //   includes: ["Admin"],
        // },

        // {
        //   id: "10",
        //   image: require("@/assets/images/icons/Billing.svg"),
        //   title: "Billing/done",
        //   name: "Billing/done",
        //   // route: "billing",
        //   route: "billing/done",
        // },
        // {
        //   id: "04",
        //   image: require("@/assets/images/icons/icon5.png"),
        //   title: "login-flow",
        //   route: "login-flow",
        // },
        // {
        //   id: "05",
        //   image: require("@/assets/images/icons/icon4.png"),
        //   title: "Marcom",
        //   route: "marcom-logo",
        // },
      ],
    };
  },
  // components: {
  //   ChevronDownIcon,
  //   ChevronUpIcon,
  //   PlayCircleIcon,
  // },
  // computed: {
  //   currentRoute() {
  //     return this.$router;
  //   },
  // },

  computed: {
    ...mapState("admin", ["login", "userModules"]),
    ...mapState("admin", ["selectedPlan"]),
    ...mapState("modules", ["modulesList"]),
    ...mapState("user", ["latestVersion"]),
    ...mapState("user", ["selectedProject"]),

    filteredMenu() {
      // if (
      //   this.login.role != "Admin" &&
      //   this.userModules &&
      //   this.userModules.length
      // ) {
      //   const menu = this.DIndex.filter((x) => {
      //     return this.login.role.modules.find(
      //       (y) => y.name.toLowerCase() == x.title.toLowerCase()
      //     );
      //   });
      //   menu.unshift(this.DIndex[0]); // Dashboard
      //   return menu;
      // } else {
      //   if (this.userModules && this.userModules.length) {
      //     const menu = this.DIndex.filter((x) => {
      //       return this.userModules.find(
      //         (y) => y.name.toLowerCase() == x.title.toLowerCase()
      //       );
      //     });
      //     menu.unshift(this.DIndex[1]); //Control Center
      //     menu.unshift(this.DIndex[0]); // Dashboard
      //     return menu;
      //   } else {
      //     return this.DIndex;
      //   }
      // }
      if (["Admin", "Developer"].includes(this.login.role)) {
        return this.DIndex;
      } else {
        const arr = this.DIndex.filter(
          (x) =>
            this.modules.some((y) => x.includes.includes(y)) ||
            !x.includes.length
        );
        return arr;
      }
    },

    ...mapState("brandProfile", ["brandProfile"]),
    ...mapState("IntellectualProperty", ["toggle"]),
    ...mapState("user", ["selectedProject"]),
  },
  watch: {
    $route(name) {
      console.log(name, "route Hello");
    },
    toggle(old, newval) {
      if (old != newval) {
        this.filteredMenu();
      }
    },
  },
  methods: {
    checkInternalRoute(route) {
      if (typeof route === "string") {
        return `${this.$route.path}`.includes(`${route}`.toLowerCase());
      }
    },

    imageUrl(row) {
      return `${this.$imageURL}/${row}`;
    },
    handleClick(name, item) {
      let access = false;
      this.modulesList.forEach((x) => {
        if (x.name === item.name) {
          access = x.access_control;
        }
      });
      if (!access) {
        this.$router.push({ name: "coming" });
      } else {
        if (this.toggle === false) {
          if (name === "billing") {
            if (this.selectedPlan[0].subscription.name === "Free") {
              this.centerDialogVisible = true;
            } else {
              this.$router.push({ name: name });
            }
          } else {
            this.$router.push({ name: name });
          }
        } else if (this.toggle === true) {
          if (name === "dashboard" || name === "controlCenter") {
            this.$router.push({ name: name });
          }
        }
      }
    },
    handleBilling() {
      if (this.selectedPlan[0].subscription.name === "Free") {
        this.centerDialogVisible = true;
      } else {
        this.$router.push({ name: "billing" });
      }
    },
    selected(item) {
      this.isSelected = item;
    },
    handleCome(name) {
      this.$router.push({ name: name });
    },
    async imagePreview() {
      let text = this.brandProfile.primaryLogo;
      let result = text.includes(`${this.$imageURL}`);
      if (result === true) {
        this.brandProfile.primaryLogo = text;
      } else {
        this.brandProfile.primaryLogo = `${this.$imageURL}/` + text;
      }
    },
    async getExtensions() {
      let payload = {
        projectName: this.selectedProject.projectName,
      };
      let data = await this.$store.dispatch(
        "Extensions/getExtensionRequest",
        payload
      );
      if (this.userModules) {
        this.modules = [...data.data, ...this.userModules];
      } else {
        this.modules = [...data.data];
      }
    },
    async logout() {
      try {
        // localStorage.setItem("token", "");
        await this.$store.commit("RESET_STATE");
        // this.$store.commit("admin/USER_LOGIN", { key: "login", value: {} });
        if (!Object.keys(this.$store.state.admin.login).length) {
          this.$router.push({ name: "login" });

          // this.$router.push({ name: "page-login" });
          // this.$router.push("/").catch(() => {});
        }
      } catch (err) {}
    },
    async getCustomPages() {
      let FilteredCustomPages = [];
      // every custom pages made from cera
      this.adminCustomPages = await this.$store.dispatch("AdminPages/GET");
      // if admin show all custom pages
      if (["Admin", "Developer"].includes(this.login.role)) {
        for (let i = 0; i < this.adminCustomPages.data.length; i++) {
          FilteredCustomPages[i] = this.adminCustomPages.data[i].name;
        }
      }
      // else show custom pages which is given permission to user by admin management which is created in role management
      else {
        let array = this.adminCustomPages.data.filter((x) =>
          this.userModules.includes(x.name)
        );

        for (let i = 0; i < array.length; i++) {
          FilteredCustomPages[i] = array[i].name;
        }
      }
      let data = [
        ...[
          "User Management",
          "Blogs",
          "Portfolio",
          "Ecommerce",
          "OTT",
          "Metaverse",
          "WhatsApp Bot",
          "E-learning",
        ],
        ...FilteredCustomPages,
      ];
      let index = this.DIndex.findIndex((x) => x.name == "My Admin");
      this.DIndex[index].includes = data;
    },
  },

  async mounted() {
    await this.$store.dispatch("modules/getModules");

    if (process.env.VUE_APP_COMMUNITY_NAME === "nhrdn") {
      await this.$store.dispatch("user/getVersion", {
        projectName: "brained-admin-vue",
      });
    } else {
      await this.$store.dispatch("user/getVersion", {
        projectName: process.env.VUE_APP_COMMUNITY_NAME,
      });
    }
    await this.$store.dispatch("billing/getPlan");
    await this.getExtensions();
    await this.getCustomPages();
    // await this.$store.dispatch("billing/getModules");
  },
};
</script>
